<template>
  <v-card :disabled="isProcessing" :loading="isProcessing">
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="success"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-toolbar-title>{{ $t("DEAL_TYPES.TITLE") }}</v-toolbar-title>
      </v-tab>
      <v-spacer></v-spacer>
      <div class="buttons-tab">
        <v-btn
          v-if="hasPermissions('deal-types-create')"
          class="mr-4 success"
          :disabled="isProcessing"
          @click="handleCreateClick"
        >
          {{ $t("GENERAL.LABELS.CREATE_BUTTON") }}
        </v-btn>
      </div>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-0">
            <Table
              v-if="userStatePrepared"
              ref="deal-types-table"
              height="500"
              name="deal-types-table"
              :headers="headers"
              :blink-row-item-key="blinkRowItemKey"
              :server-data-options="{
                method: tableItemsMethod,
              }"
              :items-per-page="100"
              :loading="isProcessing"
              dense
              fixed-header
              multi-sort
              filterable
            >
              <template
                v-for="(header, index) in headers"
                v-slot:[`item.${header.value}`]="{ item }"
              >
                <span
                  v-if="header.value === 'options'"
                  :key="index"
                  class="d-flex align-center justify-center flex-nowrap"
                >
                  <v-btn
                    v-if="hasPermissions('deal-types-edit') && !item.item.is_system"
                    icon
                    color="primary"
                    @click="handleEditClick(item.item.id)"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="hasPermissions('deal-types-delete') && !item.item.is_system"
                    icon
                    color="red"
                    @click="handleDeleteClick(item.item.id)"
                  >
                    <v-icon dark>mdi-trash-can</v-icon>
                  </v-btn>
                </span>
                <template v-else-if="header.value === 'is_system'">
                  <v-chip
                    :key="index"
                    x-small
                    :color="item.value ? 'primary' : 'grey'"
                    dark
                  >
                    {{
                      item.value
                        ? $t("DEAL_TYPES.SYSTEM")
                        : $t("DEAL_TYPES.CUSTOM")
                    }}
                  </v-chip>
                </template>
                <template v-else>
                  {{ item.value || "-" }}
                </template>
              </template>
            </Table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <Confirm
      v-model="deleteConfirm"
      :content="$t('GENERAL.DELETE_CONFIRM')"
      @confirm="deleteDealType"
      @decline="deleteConfirm = false"
    />
  </v-card>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import Confirm from "@/views/partials/dialogs/Confirm.vue";
import { SHOW_SNACK } from "@/store/snack.module";
import userStateService from "@/common/userState.service.js";
import {
  GET_DEAL_TYPES,
  DELETE_DEAL_TYPE,
} from "@/store/dealTypes.module";

export default {
  name: "ListDealTypes",
  components: {
    Table,
    Confirm,
  },
  data() {
    return {
      tableName: "deal-types-table",
      blinkRowItemKey: null,
      userStatePrepared: false,
      tab: "tab-1",
      isProcessing: false,
      tableItemsMethod: GET_DEAL_TYPES,
      deleteConfirm: false,
      dealTypeForDelete: null,
      headers: [
        {
          text: "#",
          value: "id",
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("GENERAL.LABELS.NAME"),
          value: "name",
          align: "center",
          width: "32%",
        },
        {
          text: this.$t("DEAL_TYPES.SLUG"),
          value: "slug",
          align: "center",
          width: "25%",
        },
        {
          text: this.$t("DEAL_TYPES.TYPE"),
          value: "is_system",
          align: "center",
          width: "15%",
        },
        {
          text: this.$t("GENERAL.TABLE.OPTIONS_COLUMN"),
          value: "options",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
    };
  },
  mounted() {
    this.blinkRowItemKey = userStateService.getState(
      `table-state.${this.tableName}.blinkRowItemKey`,
      null
    );
    this.userStatePrepared = true;
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    handleCreateClick() {
      this.$router.push({ name: "deal-types-create" });
    },
    handleEditClick(id) {
      userStateService.setState(
        `table-state.${this.tableName}.blinkRowItemKey`,
        id
      );

      this.$router.push({ name: "deal-types-edit", params: { id } });
    },
    handleDeleteClick(id) {
      this.dealTypeForDelete = id;
      this.deleteConfirm = true;
    },
    deleteDealType() {
      this.isProcessing = true;

      this.$store
        .dispatch(DELETE_DEAL_TYPE, this.dealTypeForDelete)
        .then(() => {
          this.$refs["deal-types-table"].fetchServerData();
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            type: "error",
            message: this.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.isProcessing = false;
          this.deleteConfirm = false;
        });
    },
  },
};
</script>
